import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './shared/components/login/login.component';
import { GuardService } from './shared/services/guard/guard.service';

// Note: We have to display all these routes to let the webpack module angular-router-loader do his job correctly
// (for curious: it take loadChildren string and insert a require() function to lazyLoad the file)
const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: 'home',
        loadChildren: () => import('../app_home/home.module').then(m => m.HomeModule),
        canActivate: [GuardService]
    },
    {
        path: 'iaqobohotel',
        loadChildren: () => import('../app_iaqobohotel/iaqobohotel.module').then(m => m.IaqobohotelModule),
        canActivate: [GuardService]
    },
    {
        path: 'locobook',
        loadChildren: () => import('../app_locobook/locobook.module').then(m => m.LocobookModule),
        canActivate: [GuardService]
    },
    {
        path: 'synchronyme',
        loadChildren: () => import('../app_synchronyme/synchronyme.module').then(m => m.SynchronymeModule),
        canActivate: [GuardService]
    },
    {
        path: 'sasha',
        loadChildren: () => import('../app_sasha/sasha.module').then(m => m.SashaModule),
        canActivate: [GuardService],
        data: { permissionPath: 'sasha.use' }
    },
    {
        path: 'quotation',
        loadChildren: () => import('../app_quotation/quotation.module').then(m => m.QuotationModule),
        canActivate: [GuardService],
        data: { permissionPath: 'quotation.use' }
    },
    {
        path: 'dashboard',
        loadChildren: () => import('../app_dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [GuardService],
        data: { permissionPath: 'dashboard.use' }
    },
    {
        path: 'watabilight',
        loadChildren: () => import('../app_watabilight/watabilight.module').then(m => m.WatabilightModule),
        // canActivate: [GuardService],
        // data: { permissionPath: 'watabilight.use' }
    },
    {
        path: 'login',
        component: LoginComponent
    },
    { path: '**', redirectTo: '/home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class RoutingModule {
}
